import React from "react";

const TextToSpeechIcon = ({ height = 14, width = 14, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.58008 0C5.99413 0.00018914 6.33008 0.335903 6.33008 0.75V11.6182C6.32984 12.0321 5.99398 12.368 5.58008 12.3682C5.16601 12.3682 4.83032 12.0322 4.83008 11.6182V0.75C4.83008 0.335786 5.16586 0 5.58008 0ZM10.4102 1.20703C10.8242 1.20716 11.16 1.54304 11.1602 1.95703V9.80566C11.1602 10.2198 10.8243 10.5555 10.4102 10.5557C9.99594 10.5557 9.66016 10.2199 9.66016 9.80566V1.95703C9.66032 1.54296 9.99605 1.20703 10.4102 1.20703ZM3.16504 1.81152C3.57907 1.81174 3.91504 2.14745 3.91504 2.56152V9.20312C3.91477 9.61697 3.5789 9.95291 3.16504 9.95312C2.75099 9.95312 2.41531 9.61711 2.41504 9.20312V2.56152C2.41504 2.14731 2.75083 1.81152 3.16504 1.81152ZM7.99512 3.01855C8.40916 3.01871 8.74506 3.35449 8.74512 3.76855V7.99512C8.74504 8.40916 8.40915 8.74496 7.99512 8.74512C7.58095 8.74512 7.2452 8.40926 7.24512 7.99512V3.76855C7.24518 3.35439 7.58094 3.01855 7.99512 3.01855ZM0.75 4.22656C1.164 4.22681 1.5 4.5625 1.5 4.97656V6.78809C1.4997 7.20189 1.16382 7.53784 0.75 7.53809C0.335971 7.53809 0.000299663 7.20204 0 6.78809V4.97656C0 4.56235 0.335786 4.22656 0.75 4.22656ZM12.8252 4.22656C13.2393 4.22666 13.5752 4.56241 13.5752 4.97656V6.78809C13.5749 7.20198 13.2391 7.53799 12.8252 7.53809C12.4112 7.53809 12.0755 7.20204 12.0752 6.78809V4.97656C12.0752 4.56235 12.411 4.22656 12.8252 4.22656Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TextToSpeechIcon;
